import Vue from "vue";

import Vuetify from "vuetify";
import "@mdi/font/css/materialdesignicons.min.css";
import "vuetify/dist/vuetify.min.css";

import hu from "vuetify/es5/locale/hu";

Vue.use(Vuetify);

const config = {
  icons: {
    iconFont: "mdi"
  },
  rtl: false,
  theme: {
    themes: {
      light: {
        primary: "#A82B31",
        secondary: "#BCCF2C",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107"
      },
      dark: {
        primary: "#A82B31",
        secondary: "#BCCF2C",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    }
  },
  lang: {
    locales: {
      hu
    },
    current: "hu"
  }
};

export default new Vuetify(config);
